import Vue from "vue";
import router from "vue-router";
import ShopLayout from "@/components/layout/ShopLayout";

//获取原型对象上的push函数
const originalPush = router.prototype.push;
//修改原型对象中的push方法
router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(router);

export const merchantRouter = [
  {
    path: "/merchantHome",
    redirect: "/merchant/home",
    name: "首页",
    component: () => import("@/view/Home"),
    children: [
      {
        path: "/merchant/home",
        name: "首页",
        meta: {
          hidden: true,
        },
        component: () => import("@/view/merchants/home"),
      },
    ],
  },
  {
    path: "/merchantInfo",
    redirect: "/merchant/info",
    name: "商户信息",
    component: () => import("@/view/Home"),
    children: [
      {
        path: "/merchant/info",
        name: "商户信息",
        meta: {
          hidden: true,
        },
        component: () => import("@/view/merchants/info"),
      },
    ],
  },
  {
    path: "/order",
    name: "订单管理",
    component: () => import("@/view/Home"),
    children: [
      {
        path: "/order/receive",
        name: "代收订单",
        component: () => import("@/view/merchants/order/receive"),
      },
      {
        path: "/order/pay",
        name: "代付订单",
        component: () => import("@/view/merchants/order/pay"),
      },
    ],
  },
  {
    path: "/finance",
    name: "财务管理",
    component: () => import("@/view/Home"),
    children: [
      {
        path: "/finance/account",
        name: "资金账户",
        component: () => import("@/view/merchants/finance/account"),
      },
      {
        path: "/finance/recharge",
        name: "余额充值",
        component: () => import("@/view/merchants/finance/recharge"),
      },
      {
        path: "/finance/withdraw",
        name: "结算提现",
        component: () => import("@/view/merchants/finance/withdraw"),
      },
      {
        path: "/finance/water",
        name: "资金流水",
        component: () => import("@/view/merchants/finance/water"),
      },
    ],
  },
  {
    path: "/merchantStatement",
    redirect: "/merchant/statement",
    name: "数据报表",
    component: () => import("@/view/Home"),
    children: [
      {
        path: "/merchant/statement",
        name: "数据报表",
        component: () => import("@/view/merchants/statement"),
      },
    ],
  },
];

export default new router({
  routes: [
    {
      path: "/",
      redirect: "/login",
      hidden: true,
    },
    {
      path: "/login",
      name: "login",
      hidden: true,
      component: () => import("@/components/Login"),
    },
    {
      path: "/agentLogin",
      name: "agentLogin",
      hidden: true,
      component: () => import("@/components/agentLogin"),
    },
    {
      path: "/pcLogin",
      name: "pcLogin",
      hidden: true,
      component: () => import("@/components/pcLogin"),
    },
    {
      path: "/orderQuery",
      name: "orderQuery",
      hidden: true,
      redirect: "/shop/orderQuery",
    },
    {
      path: "/customerLogin",
      name: "customerLogin",
      hidden: true,
      component: () => import("@/components/customerLogin"),
    },
    {
      path: "/allBill",
      name: "allBill",
      hidden: true,
      component: () => import("@/view/allBill"),
    },
    {
      path: "/telegramLogin",
      name: "telegramLogin",
      hidden: true,
      component: () => import("@/components/telegramLogin"),
    },
    ...merchantRouter,
  ],
  mode: "hash",
  router,
});
